export const COUNTRY_CODES = [
  { name: "Afghanistan", code: "AF", dial_code: "+93", max_length: 9 },
  { name: "Albania", code: "AL", dial_code: "+355", max_length: 9 },
  { name: "Algeria", code: "DZ", dial_code: "+213", max_length: 9 },
  { name: "American Samoa", code: "AS", dial_code: "+1", max_length: 10 },
  { name: "Andorra", code: "AD", dial_code: "+376", max_length: 9 },
  { name: "Angola", code: "AO", dial_code: "+244", max_length: 9 },
  { name: "Anguilla", code: "AI", dial_code: "+1", max_length: 10 },
  { name: "Antigua & Barbuda", code: "AG", dial_code: "+1", max_length: 10 },
  { name: "Argentina", code: "AR", dial_code: "+54", max_length: 10 },
  { name: "Armenia", code: "AM", dial_code: "+374", max_length: 8 },
  { name: "Aruba", code: "AW", dial_code: "+297", max_length: 7 },
  { name: "Australia", code: "AU", dial_code: "+61", max_length: 9 },
  { name: "Austria", code: "AT", dial_code: "+43", max_length: 10 },
  { name: "Azerbaijan", code: "AZ", dial_code: "+994", max_length: 9 },
  { name: "Bahamas", code: "BS", dial_code: "+1", max_length: 10 },
  { name: "Bahrain", code: "BH", dial_code: "+973", max_length: 8 },
  { name: "Bangladesh", code: "BD", dial_code: "+880", max_length: 11 },
  { name: "Barbados", code: "BB", dial_code: "+1", max_length: 10 },
  { name: "Belarus", code: "BY", code: "BY", dial_code: "+375", max_length: 9 },
  { name: "Belgium", code: "BE", dial_code: "+32", max_length: 9 },
  { name: "Belize", code: "BZ", dial_code: "+501", max_length: 7 },
  { name: "Benin", code: "BJ", dial_code: "+229", max_length: 8 },
  { name: "Bermuda", code: "BM", dial_code: "+1", max_length: 10 },
  { name: "Bhutan", code: "BT", dial_code: "+975", max_length: 8 },
  { name: "Bolivia", code: "BO", dial_code: "+591", max_length: 8 },
  { name: "Bosnia & Herzegovina", code: "BA", dial_code: "+387", max_length: 8 },
  { name: "Botswana", code: "BW", dial_code: "+267", max_length: 8 },
  { name: "Brazil", code: "BR", dial_code: "+55", max_length: 11 },
  { name: "British Virgin Islands", code: "VG", dial_code: "+1", max_length: 10 },
  { name: "Brunei", code: "BN", dial_code: "+673", max_length: 7 },
  { name: "Bulgaria", code: "BG", dial_code: "+359", max_length: 9 },
  { name: "Burkina Faso", code: "BF", dial_code: "+226", max_length: 8 },
  { name: "Burundi", code: "BI", dial_code: "+257", max_length: 8 },
  { name: "Cambodia", code: "KH", dial_code: "+855", max_length: 9 },
  { name: "Cameroon", code: "CM", dial_code: "+237", max_length: 9 },
  { name: "Canada", code: "CA", dial_code: "+1", max_length: 10 },
  { name: "Cape Verde", code: "CV", dial_code: "+238", max_length: 7 },
  { name: "Cayman Islands", code: "KY", dial_code: "+1", max_length: 10 },
  { name: "Central African Republic", code: "CF", dial_code: "+236", max_length: 8 },
  { name: "Chad", code: "TD", dial_code: "+235", max_length: 8 },
  { name: "Chile", code: "CL", dial_code: "+56", max_length: 9 },
  { name: "China", code: "CN", dial_code: "+86", max_length: 11 },
  { name: "Colombia", code: "CO", dial_code: "+57", max_length: 10 },
  { name: "Comoros", code: "KM", dial_code: "+269", max_length: 7 },
  { name: "Congo (Brazzaville)", code: "CG", dial_code: "+242", max_length: 9 },
  { name: "Congo (Kinshasa)", code: "CD", dial_code: "+243", max_length: 9 },
  { name: "Cook Islands", code: "CK", dial_code: "+682", max_length: 5 },
  { name: "Costa Rica", code: "CR", dial_code: "+506", max_length: 8 },
  { name: "Côte d'Ivoire", code: "CI", dial_code: "+225", max_length: 10 },
  { name: "Croatia", code: "HR", dial_code: "+385", max_length: 9 },
  { name: "Cuba", code: "CU", dial_code: "+53", max_length: 8 },
  { name: "Curacao", code: "CW", dial_code: "+599", max_length: 7 },
  { name: "Cyprus", code: "CY", dial_code: "+357", max_length: 8 },
  { name: "Czech Republic", code: "CZ", dial_code: "+420", max_length: 9 },
  { name: "Denmark", code: "DK", dial_code: "+45", max_length: 8 },
  { name: "Djibouti", code: "DJ", dial_code: "+253", max_length: 8 },
  { name: "Dominica", code: "DM", dial_code: "+1", max_length: 10 },
  { name: "Dominican Republic", code: "DO", dial_code: "+1", max_length: 10 },
  { name: "Ecuador", code: "EC", dial_code: "+593", max_length: 9 },
  { name: "Egypt", code: "EG", dial_code: "+20", max_length: 10 },
  { name: "El Salvador", code: "SV", dial_code: "+503", max_length: 8 },
  { name: "Equatorial Guinea", code: "GQ", dial_code: "+240", max_length: 9 },
  { name: "Eritrea", code: "ER", dial_code: "+291", max_length: 7 },
  { name: "Estonia", code: "EE", dial_code: "+372", max_length: 8 },
  { name: "Eswatini", code: "SZ", dial_code: "+268", max_length: 8 },
  { name: "Ethiopia", code: "ET", dial_code: "+251", max_length: 9 },
  { name: "Falkland Islands", code: "FK", dial_code: "+500", max_length: 5 },
  { name: "Faroe Islands", code: "FO", dial_code: "+298", max_length: 6 },
  { name: "Fiji", code: "FJ", dial_code: "+679", max_length: 7 },
  { name: "Finland", code: "FI", dial_code: "+358", max_length: 9 },
  { name: "France", code: "FR", dial_code: "+33", max_length: 9 },
  { name: "French Polynesia", code: "PF", dial_code: "+689", max_length: 6 },
  { name: "Gabon", code: "GA", dial_code: "+241", max_length: 8 },
  { name: "Gambia", code: "GM", dial_code: "+220", max_length: 7 },
  { name: "Georgia", code: "GE", dial_code: "+995", max_length: 9 },
  { name: "Germany", code: "DE", dial_code: "+49", max_length: 11 },
  { name: "Ghana", code: "GH", dial_code: "+233", max_length: 9 },
  { name: "Gibraltar", code: "GI", dial_code: "+350", max_length: 8 },
  { name: "Greece", code: "GR", dial_code: "+30", max_length: 10 },
  { name: "Greenland", code: "GL", dial_code: "+299", max_length: 6 },
  { name: "Grenada", code: "GD", dial_code: "+1", max_length: 10 },
  { name: "Guam", code: "GU", dial_code: "+1", max_length: 10 },
  { name: "Guatemala", code: "GT", dial_code: "+502", max_length: 8 },
  { name: "Guernsey", code: "GG", dial_code: "+44", max_length: 10 },
  { name: "Guinea", code: "GN", dial_code: "+224", max_length: 9 },
  { name: "Guinea-Bissau", code: "GW", dial_code: "+245", max_length: 7 },
  { name: "Guyana", code: "GY", dial_code: "+592", max_length: 7 },
  { name: "Haiti", code: "HT", dial_code: "+509", max_length: 8 },
  { name: "Honduras", code: "HN", dial_code: "+504", max_length: 8 },
  { name: "Hong Kong", code: "HK", dial_code: "+852", max_length: 8 },
  { name: "Hungary", code: "HU", dial_code: "+36", max_length: 9 },
  { name: "Iceland", code: "IS", dial_code: "+354", max_length: 7 },
  { name: "India", code: "IN", dial_code: "+91", max_length: 10 },
  { name: "Indonesia", code: "ID", dial_code: "+62", max_length: 11 },
  { name: "Iran", code: "IR", dial_code: "+98", max_length: 10 },
  { name: "Iraq", code: "IQ", dial_code: "+964", max_length: 10 },
  { name: "Ireland", code: "IE", dial_code: "+353", max_length: 9 },
  { name: "Isle of Man", code: "IM", dial_code: "+44", max_length: 10 },
  { name: "Israel", code: "IL", dial_code: "+972", max_length: 9 },
  { name: "Italy", code: "IT", dial_code: "+39", max_length: 10 },
  { name: "Jamaica", code: "JM", dial_code: "+1", max_length: 10 },
  { name: "Japan", code: "JP", dial_code: "+81", max_length: 10 },
  { name: "Jersey", code: "JE", dial_code: "+44", max_length: 10 },
  { name: "Jordan", code: "JO", dial_code: "+962", max_length: 9 },
  { name: "Kazakhstan", code: "KZ", dial_code: "+7", max_length: 10 },
  { name: "Kenya", code: "KE", dial_code: "+254", max_length: 9 },
  { name: "Kiribati", code: "KI", dial_code: "+686", max_length: 5 },
  { name: "Kosovo", code: "XK", dial_code: "+383", max_length: 8 },
  { name: "Kuwait", code: "KW", dial_code: "+965", max_length: 8 },
  { name: "Kyrgyzstan", code: "KG", dial_code: "+996", max_length: 9 },
  { name: "Laos", code: "LA", dial_code: "+856", max_length: 9 },
  { name: "Latvia", code: "LV", dial_code: "+371", max_length: 8 },
  { name: "Lebanon", code: "LB", dial_code: "+961", max_length: 8 },
  { name: "Lesotho", code: "LS", dial_code: "+266", max_length: 8 },
  { name: "Liberia", code: "LR", dial_code: "+231", max_length: 8 },
  { name: "Libya", code: "LY", dial_code: "+218", max_length: 10 },
  { name: "Liechtenstein", code: "LI", dial_code: "+423", max_length: 7 },
  { name: "Lithuania", code: "LT", dial_code: "+370", max_length: 8 },
  { name: "Luxembourg", code: "LU", dial_code: "+352", max_length: 9 },
  { name: "Macao", code: "MO", dial_code: "+853", max_length: 8 },
  { name: "Macedonia", code: "MK", dial_code: "+389", max_length: 8 },
  { name: "Madagascar", code: "MG", dial_code: "+261", max_length: 9 },
  { name: "Malawi", code: "MW", dial_code: "+265", max_length: 9 },
  { name: "Malaysia", code: "MY", dial_code: "+60", max_length: 10 },
  { name: "Maldives", code: "MV", dial_code: "+960", max_length: 7 },
  { name: "Mali", code: "ML", dial_code: "+223", max_length: 8 },
  { name: "Malta", code: "MT", dial_code: "+356", max_length: 8 },
  { name: "Marshall Islands", code: "MH", dial_code: "+692", max_length: 7 },
  { name: "Mauritania", code: "MR", dial_code: "+222", max_length: 8 },
  { name: "Mauritius", code: "MU", dial_code: "+230", max_length: 8 },
  { name: "Mayotte", code: "YT", dial_code: "+262", max_length: 9 },
  { name: "Mexico", code: "MX", dial_code: "+52", max_length: 10 },
  { name: "Micronesia", code: "FM", dial_code: "+691", max_length: 7 },
  { name: "Moldova", code: "MD", dial_code: "+373", max_length: 8 },
  { name: "Monaco", code: "MC", dial_code: "+377", max_length: 8 },
  { name: "Mongolia", code: "MN", dial_code: "+976", max_length: 8 },
  { name: "Montenegro", code: "ME", dial_code: "+382", max_length: 8 },
  { name: "Montserrat", code: "MS", dial_code: "+1", max_length: 10 },
  { name: "Morocco", code: "MA", dial_code: "+212", max_length: 9 },
  { name: "Mozambique", code: "MZ", dial_code: "+258", max_length: 9 },
  { name: "Myanmar", code: "MM", dial_code: "+95", max_length: 9 },
  { name: "Namibia", code: "NA", dial_code: "+264", max_length: 9 },
  { name: "Nauru", code: "NR", dial_code: "+674", max_length: 7 },
  { name: "Nepal", code: "NP", dial_code: "+977", max_length: 10 },
  { name: "Netherlands", code: "NL", dial_code: "+31", max_length: 9 },
  { name: "New Caledonia", code: "NC", dial_code: "+687", max_length: 6 },
  { name: "New Zealand", code: "NZ", dial_code: "+64", max_length: 9 },
  { name: "Nicaragua", code: "NI", dial_code: "+505", max_length: 8 },
  { name: "Niger", code: "NE", dial_code: "+227", max_length: 8 },
  { name: "Nigeria", code: "NG", dial_code: "+234", max_length: 10 },
  { name: "Niue", code: "NU", dial_code: "+683", max_length: 4 },
  { name: "Norfolk Island", code: "NF", dial_code: "+672", max_length: 5 },
  { name: "North Korea", code: "KP", dial_code: "+850", max_length: 9 },
  { name: "Northern Mariana Islands", code: "MP", dial_code: "+1", max_length: 10 },
  { name: "Norway", code: "NO", dial_code: "+47", max_length: 8 },
  { name: "Oman", code: "OM", dial_code: "+968", max_length: 8 },
  { name: "Pakistan", code: "PK", dial_code: "+92", max_length: 10 },
  { name: "Palau", code: "PW", dial_code: "+680", max_length: 7 },
  { name: "Palestine", code: "PS", dial_code: "+970", max_length: 9 },
  { name: "Panama", code: "PA", dial_code: "+507", max_length: 8 },
  { name: "Papua New Guinea", code: "PG", dial_code: "+675", max_length: 8 },
  { name: "Paraguay", code: "PY", dial_code: "+595", max_length: 9 },
  { name: "Peru", code: "PE", dial_code: "+51", max_length: 9 },
  { name: "Philippines", code: "PH", dial_code: "+63", max_length: 10 },
  { name: "Poland", code: "PL", dial_code: "+48", max_length: 9 },
  { name: "Portugal", code: "PT", dial_code: "+351", max_length: 9 },
  { name: "Puerto Rico", code: "PR", dial_code: "+1", max_length: 10 },
  { name: "Qatar", code: "QA", dial_code: "+974", max_length: 8 },
  { name: "Réunion", code: "RE", dial_code: "+262", max_length: 9 },
  { name: "Romania", code: "RO", dial_code: "+40", max_length: 9 },
  { name: "Russia", code: "RU", dial_code: "+7", max_length: 10 },
  { name: "Rwanda", code: "RW", dial_code: "+250", max_length: 9 },
  { name: "Saint Kitts & Nevis", code: "KN", dial_code: "+1", max_length: 10 },
  { name: "Saint Lucia", code: "LC", dial_code: "+1", max_length: 10 },
  { name: "Saint Martin", code: "MF", dial_code: "+590", max_length: 9 },
  { name: "Samoa", code: "WS", dial_code: "+685", max_length: 7 },
  { name: "San Marino", code: "SM", dial_code: "+378", max_length: 9 },
  { name: "Saudi Arabia", code: "SA", dial_code: "+966", max_length: 9 },
  { name: "Senegal", code: "SN", dial_code: "+221", max_length: 9 },
  { name: "Serbia", code: "RS", dial_code: "+381", max_length: 9 },
  { name: "Seychelles", code: "SC", dial_code: "+248", max_length: 7 },
  { name: "Sierra Leone", code: "SL", dial_code: "+232", max_length: 8 },
  { name: "Singapore", code: "SG", dial_code: "+65", max_length: 8 },
  { name: "Sint Maarten", code: "SX", dial_code: "+1", max_length: 10 },
  { name: "Slovakia", code: "SK", dial_code: "+421", max_length: 9 },
  { name: "Slovenia", code: "SI", dial_code: "+386", max_length: 9 },
  { name: "Solomon Islands", code: "SB", dial_code: "+677", max_length: 7 },
  { name: "Somalia", code: "SO", dial_code: "+252", max_length: 8 },
  { name: "South Africa", code: "ZA", dial_code: "+27", max_length: 9 },
  { name: "South Korea", code: "KR", dial_code: "+82", max_length: 10 },
  { name: "South Sudan", code: "SS", dial_code: "+211", max_length: 9 },
  { name: "Spain", code: "ES", dial_code: "+34", max_length: 9 },
  { name: "Sri Lanka", code: "LK", dial_code: "+94", max_length: 9 },
  { name: "St. Barthélemy", code: "BL", dial_code: "+590", max_length: 9 },
  { name: "St. Helena", code: "SH", dial_code: "+290", max_length: 4 },
  { name: "St. Pierre & Miquelon", code: "PM", dial_code: "+508", max_length: 6 },
  { name: "Sudan", code: "SD", dial_code: "+249", max_length: 9 },
  { name: "Suriname", code: "SR", dial_code: "+597", max_length: 7 },
  { name: "Svalbard & Jan Mayen", code: "SJ", dial_code: "+47", max_length: 8 },
  { name: "Sweden", code: "SE", dial_code: "+46", max_length: 9 },
  { name: "Switzerland", code: "CH", dial_code: "+41", max_length: 9 },
  { name: "Syria", code: "SY", dial_code: "+963", max_length: 9 },
  { name: "Taiwan", code: "TW", dial_code: "+886", max_length: 9 },
  { name: "Tajikistan", code: "TJ", dial_code: "+992", max_length: 9 },
  { name: "Tanzania", code: "TZ", dial_code: "+255", max_length: 9 },
  { name: "Thailand", code: "TH", dial_code: "+66", max_length: 9 },
  { name: "Timor-Leste", code: "TL", dial_code: "+670", max_length: 7 },
  { name: "Togo", code: "TG", dial_code: "+228", max_length: 8 },
  { name: "Tokelau", code: "TK", dial_code: "+690", max_length: 4 },
  { name: "Tonga", code: "TO", dial_code: "+676", max_length: 5 },
  { name: "Trinidad & Tobago", code: "TT", dial_code: "+1", max_length: 10 },
  { name: "Tunisia", code: "TN", dial_code: "+216", max_length: 8 },
  { name: "Turkey", code: "TR", dial_code: "+90", max_length: 10 },
  { name: "Turkmenistan", code: "TM", dial_code: "+993", max_length: 8 },
  { name: "Turks & Caicos Islands", code: "TC", dial_code: "+1", max_length: 10 },
  { name: "Tuvalu", code: "TV", dial_code: "+688", max_length: 5 },
  { name: "U.S. Virgin Islands", code: "VI", dial_code: "+1", max_length: 10 },
  { name: "Uganda", code: "UG", dial_code: "+256", max_length: 9 },
  { name: "Ukraine", code: "UA", dial_code: "+380", max_length: 9 },
  { name: "United Arab Emirates", code: "AE", dial_code: "+971", max_length: 9 },
  { name: "United Kingdom", code: "GB", dial_code: "+44", max_length: 10 },
  { name: "United States", code: "US", dial_code: "+1", max_length: 10 },
  { name: "Uruguay", code: "UY", dial_code: "+598", max_length: 8 },
  { name: "Uzbekistan", code: "UZ", dial_code: "+998", max_length: 9 },
  { name: "Vanuatu", code: "VU", dial_code: "+678", max_length: 7 },
  { name: "Vatican City", code: "VA", dial_code: "+379", max_length: 6 },
  { name: "Venezuela", code: "VE", dial_code: "+58", max_length: 10 },
  { name: "Vietnam", code: "VN", dial_code: "+84", max_length: 10 },
  { name: "Wallis & Futuna", code: "WF", dial_code: "+681", max_length: 6 },
  { name: "Yemen", code: "YE", dial_code: "+967", max_length: 9 },
  { name: "Zambia", code: "ZM", dial_code: "+260", max_length: 9 },
  { name: "Zimbabwe", code: "ZW", dial_code: "+263", max_length: 9 }
];
